<form
	class="sdp-saml-wizard-form sdp-administrative-wizard-content"
	[formGroup]="form"
	novalidate
>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-clear"></div>
		<div
			formArrayName="ports"
			class="sdp-application-ports-form"
		>
			<div
				*ngFor="let port of formPorts.controls; let i=index; let first = first"
				class="sdp-form-control"
			>
				<div [formGroupName]="i">
					<button
						*ngIf="first"
						mat-icon-button
						(click)="addPort()"
						class="sdp-icon-button sdp-application-ports-add-port-button"
						matTooltip="{{ 'application.port.add.tooltip' | translate }}"
						[matTooltipPosition]="'above'"
						[matTooltipShowDelay]="1000"
					>
						<sdp-icon [icon]="addIcon"></sdp-icon>
						<span class="sdp-application-ports-add-port-button-text">{{ 'application.port.add.tooltip' | translate }}</span>
					</button>
					<div class="sdp-application-ports-row">
						<mat-form-field class="sdp-application-ports-port-input-container">
							<input
								matInput
								placeholder="{{ 'applications.label.portNumber' | translate }}"
								type="text"
								formControlName="portNumber"
							>
							<mat-error *ngIf="port.controls['portNumber'].hasError('invalidPort')">{{ "error.form.portNumber" | translate }}</mat-error>
							<mat-error *ngIf="port.controls['portNumber'].hasError('minGtMaxPort')">{{ "error.form.minGtMaxPort" | translate }}</mat-error>
						</mat-form-field>
						<div class="sdp-proto-form-container">
							<mat-form-field>
								<mat-select
									placeholder="{{ 'applications.label.proto' | translate }}"
									formControlName="proto"
								>
									<mat-option [value]="'tcp'">TCP</mat-option>
									<mat-option [value]="'udp'">UDP</mat-option>
									<mat-option [value]="'both'">Both</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<button
							*ngIf="i >= 1"
							mat-icon-button
							(click)="deletePort(i)"
							color="primary"
							class="sdp-icon-button sdp-application-ports-delete-port-button"
							matTooltip="{{ 'application.port.remove.tooltip' | translate }}"
							[matTooltipPosition]="'above'"
							[matTooltipShowDelay]="1000"
						>
							<sdp-icon [icon]="deleteIcon"></sdp-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="sdp-form-control"
		title=""
	>
		<mat-slide-toggle
			formControlName="icmp"
			matTooltip="{{ 'application.port.icmp.hover' | translate }}"
			[matTooltipPosition]="'above'"
			[matTooltipShowDelay]="1000"
		>
			{{ 'application.port.icmp.toggle' | translate }}
		</mat-slide-toggle>
		<mat-error
			class="sdp-warning-message"
			*ngIf="icmpNotSupported"
		>{{ "error.form.gatewayVersionOld" | translate }}</mat-error>
	</div>
</form>